<template>
  <v-navigation-drawer
    id="core-navigation-drawer"
    v-model="drawer"
    :dark="barColor !== 'rgba(228, 226, 226, 1), rgba(255, 255, 255, 0.7)'"
    :expand-on-hover="expandOnHover"
    :right="$vuetify.rtl"
    mobile-breakpoint="960"
    app
    width="260"
    v-bind="$attrs"
  >
    <template v-slot:prepend>
      <v-list-item two-line>
        <!-- <v-list-item-avatar>
          <img :src="require('@/assets/logotipo.png')">
        </v-list-item-avatar> -->

        <v-list-item-content v-if="user">
          <v-list-item-title>{{ user.name }}</v-list-item-title>
          <v-list-item-subtitle>{{ rol(user.type) }}</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
    </template>

    <v-divider class="mb-2" />

    <v-list
      expand
      nav
    >
      <div />

      <template v-for="(item, i) in items">
        <base-item-group
          v-if="item.children"
          :key="`group-${i}`"
          :item="item"
        >
          <!--  -->
        </base-item-group>

        <base-item
          v-else
          :key="`item-${i}`"
          :item="item"
        />
      </template>

      <div />
    </v-list>
  </v-navigation-drawer>
</template>

<script>
  import {
    mapState,
  } from 'vuex'

  export default {
    name: 'DashboardCoreDrawer',

    props: {
      expandOnHover: {
        type: Boolean,
        default: false,
      },
    },

    data: () => ({
      lists: [
        {
          icon: 'mdi-home',
          title: 'Inicio',
          to: '/home',
          roles: ['tutor', 'parent', 'student', 'admin'],
        },
        {
          icon: 'mdi-account-supervisor-outline',
          title: 'Estudiantes',
          to: '/panel/students',
          roles: ['tutor', 'parent'],
        },
        {
          icon: 'mdi-account-supervisor-outline',
          title: 'Tienda',
          roles: ['tutor', 'parent'],
          children: [{
                       icon: 'mdi-cart-outline',
                       title: 'Catálogo',
                       to: '/panel/store',
                     },
                     {
                       icon: 'mdi-format-list-text',
                       title: 'Mis Productos',
                       to: '/panel/products',
                     },
                     {
                       icon: 'mdi-clipboard-list-outline',
                       title: 'Órdenes',
                       to: '/panel/orders',
                     }],
        },
        {
          icon: 'mdi-playlist-check',
          title: 'Episodios',
          //roles: ['tutor', 'parent', 'student'],
          roles: ['student'],
          children: [{
                       icon: 'mdi-head-question-outline',
                       title: 'Episodio 1',
                       to: '/panel/student/0',
                     },
                    //  {
                    //    icon: 'mdi-head-question-outline',
                    //    title: 'Episodio 2',
                    //    to: '/panel/student/1',
                    //  }, {
                    //    icon: 'mdi-head-question-outline',
                    //    title: 'Episodio 3',
                    //    to: '/panel/student/2',
                    //  }, {
                    //    icon: 'mdi-head-question-outline',
                    //    title: 'Episodio 4',
                    //    to: '/panel/student/3',
                    //  }, {
                    //    icon: 'mdi-head-question-outline',
                    //    title: 'Episodio 5',
                    //    to: '/panel/student/4',
                    //  }
                    ],
        },
        {
          icon: 'mdi-playlist-check',
          title: 'Demo',
          roles: ['tutor', 'parent', ],
          children: [{
                       icon: 'mdi-head-question-outline',
                       title: 'Episodio 1',
                       to: '/panel/demoreport',
                    }]
        },
        {
          icon: 'mdi-file-pdf',
          title: 'Guiones',
          to: '/panel/scripts',
          roles: ['tutor', 'parent'],
        },
        {
          icon: 'mdi-file-pdf',
          title: 'Estadísticas',
          to: '/admin/statistics',
          roles: ['admin'],
        },
        {
          icon: 'mdi-account-supervisor-circle',
          title: 'Usuarios',
          to: '/admin/management',
          roles: ['admin'],
        },
        {
          icon: 'mdi-account',
          title: 'Perfil',
          to: '/panel/account',
          roles: ['tutor', 'parent', 'student'],
        },
      ],
      items: [],
    }),

    computed: {
      ...mapState(['barColor', 'user']),
      drawer: {
        get () {
          return this.$store.state.drawer
        },
        set (val) {
          this.$store.commit('SET_DRAWER', val)
        },
      },
      profile () {
        return {
          avatar: true,
          title: this.$t('avatar'),
        }
      },
    },
    watch: {
      user (val) {
        this.items = val ? this.lists.filter(i => i.roles.includes(this.user.type)) : []
      },
    },
    created () {
      this.user && (this.items = this.lists.filter(i => i.roles.includes(this.user.type)))
    },
    methods: {
      rol (title) {
        if (title === 'tutor') {
          return 'Profesor'
        } else if (title === 'parent') {
          return 'Padre'
        } else if (title === 'admin') {
          return 'Administrador'
        } else {
          return 'Estudiante'
        }
      },
    },
  }
</script>

<style lang="sass">
  @import '~vuetify/src/styles/tools/_rtl.sass'

  #core-navigation-drawer
    .v-list-group__header.v-list-item--active:before
      opacity: .24

    .v-list-item
      &__icon--text,
      &__icon:first-child
        justify-content: center
        text-align: center
        width: 20px

        +ltr()
          margin-right: 24px
          margin-left: 12px !important

        +rtl()
          margin-left: 24px
          margin-right: 12px !important

    .v-list--dense
      .v-list-item
        &__icon--text,
        &__icon:first-child
          margin-top: 10px

    .v-list-group--sub-group
      .v-list-item
        +ltr()
          padding-left: 8px

        +rtl()
          padding-right: 8px

      .v-list-group__header
        +ltr()
          padding-right: 0

        +rtl()
          padding-right: 0

        .v-list-item__icon--text
          margin-top: 19px
          order: 0

        .v-list-group__header__prepend-icon
          order: 2

          +ltr()
            margin-right: 8px

          +rtl()
            margin-left: 8px
</style>
